export default "__VITE_ASSET__DwsBfXAj__"